import SidebarRelated from '@/components/_blog-updates/SidebarRelated';
import { CraftSidebarRelatedProps } from './CraftSidebarRelated.types';
import { mapBlockToSidebarRelatedProps } from './CraftSidebarRelated.utils';

const CraftSidebarRelated = ({ block }: CraftSidebarRelatedProps) => {
  const props = mapBlockToSidebarRelatedProps(block);

  return <SidebarRelated {...props} />;
};

export default CraftSidebarRelated;
